export default __webpack_public_path__ + "static/media/image.c2-systems.ba8bac28.png";